module.exports = __webpack_public_path__ + "media/common/images/cta/nim-42e531d7a34a8995faf18f2a74240330.jpeg";